import { useLoaderData } from "react-router-dom";

import authenticate from "../services/auth";
import { UserProvider, useUser } from "../components/context/UserContext";
import Layout from "../components/layout/Layout";
import { ProjectRoute } from "./projects";
import { SitesRoute } from "./sites";
import MaintenancePage from "../components/pages/MaintenancePage";
import config from "../config";


type LoaderData = {
    user?: User | null;
    completed?: boolean;
};

const rootLoader = async () => {
    const INTERCOM_APP_ID = 'febi3ql0';
    const user = await authenticate();

    if (!user) {
        // -> Core whoami not working -> Show loading screen
        return { user: null };
    }

    window.Mixpanel.identify(user.hash);
    window.Mixpanel.people.set({
        $name: user.name,
        $email: user.email,
        Account: user.account_reference,
    });

    localStorage.setItem(
        "user",
        JSON.stringify({
            name: user.name,
            email: user.email,
        })
    );
    let result = window.Intercom("boot", {
        api_base: "https://api-iam.intercom.io",
        app_id: INTERCOM_APP_ID,
        name: user.name,
        email: user.email,
        user_hash: user.hash,
    });

    const apiResponse = await fetch('https://api-iam.intercom.io/messenger/web/ping', {
        credentials: 'include',
        method: 'POST',
        body: `app_id=${INTERCOM_APP_ID}&v=3&user_data={"anonymous_id":"${window.Intercom('getVisitorId')}", "email":"${user.email}","user_hash":"${user.hash}"}`,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(res => res.json());
    window.intercomUserData = apiResponse.user;
    

    return { user };
};

const RootRoute = () => {
    const { user }: LoaderData = useLoaderData();
    const { setUser } = useUser();

    if (!user) {
        return null;
    }

    // Check if maintenance mode is enabled
    if (config.maintenanceMode) {
        return <MaintenancePage />;
    }

    setUser(user);

    return (
        <UserProvider initialUser={user}>
            <Layout />
        </UserProvider>
    );
};

const IndexRoute = () => {
    const { user } = useUser();

    if (user.account_reference === "amazon") {
        return <ProjectRoute />;
    }

    return <SitesRoute />;
};

export { IndexRoute, RootRoute, rootLoader };
